export default class PeriodType {
  static get Week () { return 'week' }
  static get Month () { return 'month' }
  static get Year () { return 'year' }
}
